import loadable from "@loadable/component";
import { Loader } from "components/UI";

//Auth Users Pages
export const Login = loadable(() => import("pages/user/login"), {
  fallback: <Loader />,
});
export const ForgotPassword = loadable(() => import("pages/user/forgot"), {
  fallback: <Loader />,
});
export const ResetPassword = loadable(
  () => import("pages/user/resetPassword"),
  { fallback: <Loader /> }
);
export const SelectCompany = loadable(
  () => import("pages/user/selectCompany"),
  { fallback: <Loader /> }
);
export const LoginSso = loadable(() => import("pages/user/login/sso"), {
  fallback: <Loader />,
});
export const OnlyEmployeeRole = loadable(
  () => import("pages/user/onlyEmployeeRole"),
  { fallback: <Loader /> }
);
export const Invite = loadable(() => import("pages/user/invite"), {
  fallback: <Loader />,
});
export const TwoFactorRequired = loadable(
  () => import("pages/user/login/TwoFactorRequired"),
  {
    fallback: <Loader />,
  }
);

//Dashboard Pages
export const Dashboard = loadable(() => import("pages/dashboard"), {
  fallback: <Loader />,
});

//Employee Pages
export const Employee = loadable(() => import("pages/employee"), {
  fallback: <Loader />,
});
export const DetailEmployee = loadable(() => import("pages/employee/detail"), {
  fallback: <Loader />,
});
export const AddEmployee = loadable(() => import("pages/employee/add"), {
  fallback: <Loader />,
});
export const AddEmployeePersonal = loadable(
  () => import("pages/employee/add/AddEmployeePersonal"),
  {
    fallback: <Loader />,
  }
);
export const AddEmployeeCareer = loadable(
  () => import("pages/employee/add/AddEmployeeCareer"),
  {
    fallback: <Loader />,
  }
);
export const AddEmployeePayroll = loadable(
  () => import("pages/employee/add/AddEmployeePayroll"),
  {
    fallback: <Loader />,
  }
);
export const ImportAddEmployee = loadable(
  () => import("pages/employee/import/importAddEmployee"),
  {
    fallback: <Loader />,
  }
);
export const ImportUpdateEmployee = loadable(
  () => import("pages/employee/import/importUpdateEmployee"),
  {
    fallback: <Loader />,
  }
);
export const ImportBankAccountEmployee = loadable(
  () => import("pages/employee/import/importBankAccountEmployee"),
  {
    fallback: <Loader />,
  }
);
export const AddEmployeeLeave = loadable(() =>
  import("pages/employee/detail/leave/add")
);
export const DetailEmployeeLeave = loadable(() =>
  import("pages/employee/detail/leave/edit")
);
export const MainDetailPersonal = loadable(() =>
  import("pages/employee/detail/personal")
);
export const DetailPersonal = loadable(() =>
  import("pages/employee/detail/personal/personal")
);
export const DetailPersonalCareer = loadable(() =>
  import("pages/employee/detail/personal/career")
);
export const MainDetailLeaveAndPermission = loadable(() =>
  import("pages/employee/detail/leave")
);
export const MainNavigateEmployeeLeave = loadable(() =>
  import("pages/employee/detail/leave/content/MainLeave")
);
export const DetailContentLeave = loadable(() =>
  import("pages/employee/detail/leave/content")
);
export const MainEmployeePayroll = loadable(() =>
  import("pages/employee/detail/payroll")
);
export const DetailEmployeePayroll = loadable(() =>
  import("pages/employee/detail/payroll/detail")
);
export const EmployeeAddPayroll = loadable(() =>
  import("pages/employee/detail/payroll/add")
);
export const EmployeeEditPayroll = loadable(() =>
  import("pages/employee/detail/payroll/edit")
);
export const MainEmployeeSalaryHistory = loadable(() =>
  import("pages/employee/detail/salaryHistory")
);
export const EmployeeCareer = loadable(() =>
  import("pages/employee/detail/career")
);
export const AddCareer = loadable(() =>
  import("pages/employee/detail/career/add")
);
export const DetailEmployeeCareer = loadable(() =>
  import("pages/employee/detail/career/edit")
);
export const TerminateCareer = loadable(() =>
  import("pages/employee/detail/career/terminate")
);
export const EmployeeTracking = loadable(
  () => import("pages/employee/detail/Tracking"),
  {
    fallback: <Loader />,
  }
);
export const EmployeeAttendanceDaily = loadable(() =>
  import("pages/employee/detail/attendanceDaily")
);
export const EmployeeAttendanceHistory = loadable(() =>
  import("pages/employee/detail/attendanceHistory")
);
export const EmployeeCashReceipt = loadable(() =>
  import("pages/employee/detail/cashReceipt")
);
export const AddEmployeeCashReceipt = loadable(() =>
  import("pages/employee/detail/cashReceipt/add")
);
export const DetailEmployeeCashReceipt = loadable(() =>
  import("pages/employee/detail/cashReceipt/detail")
);
export const EmployeeReimburse = loadable(() =>
  import("pages/employee/detail/reimburse")
);
export const AddReimburseEmployee = loadable(() =>
  import("pages/employee/detail/reimburse/add")
);
export const EmployeeTask = loadable(() =>
  import("pages/employee/detail/task")
);
export const EmployeeDetailTask = loadable(() =>
  import("pages/employee/detail/task/detail")
);
export const PettyCashEmployee = loadable(() =>
  import("pages/employee/detail/pettyCash")
);

//=================Presence Pages====================//
//Attendance Approval Pages
export const AttendanceApproval = loadable(
  () => import("pages/attendanceApproval"),
  {
    fallback: <Loader />,
  }
);
export const ContentAttendanceApproval = loadable(() =>
  import("pages/attendanceApproval/content")
);
//Schedule Pages
export const Schedule = loadable(() => import("pages/schedule"), {
  fallback: <Loader />,
});
export const DetailSchedule = loadable(() => import("pages/schedule/detail"), {
  fallback: <Loader />,
});
export const EditDetailSchedule = loadable(() =>
  import("pages/schedule/edit/EditScheduleEmployee")
);
export const ContentFixedSchedule = loadable(() =>
  import("pages/schedule/content/FixedSchedule")
);
export const ContentShiftSchedule = loadable(() =>
  import("pages/schedule/content/ShiftSchedule")
);
export const ImportContentShiftSchedule = loadable(
  () => import("pages/schedule/import/shift"),
  {
    fallback: <Loader />,
  }
);
//Shift Schedule Pages
export const DetailApprovalShiftSchedule = loadable(() =>
  import("pages/shiftSchedule/detail/DetailApprovalShiftSchedule")
);
//Attendance Pages
export const Attendance = loadable(() => import("pages/attendance"), {
  fallback: <Loader />,
});
export const DailyAttendance = loadable(() =>
  import("pages/attendance/content/DailyAttendance")
);
export const SummaryAttendance = loadable(() =>
  import("pages/attendance/content/SummaryAttendance")
);
export const AttendanceTracking = loadable(
  () => import("pages/attendance/tracking"),
  {
    fallback: <Loader />,
  }
);
export const ImportAttendance = loadable(
  () => import("pages/attendance/import/attendance"),
  {
    fallback: <Loader />,
  }
);
export const ImportAddOvertime = loadable(
  () => import("pages/attendance/import/overtime/importAddOvertime"),
  {
    fallback: <Loader />,
  }
);
export const ImportUpdateOvertime = loadable(
  () => import("pages/attendance/import/overtime/importUpdateOvertime"),
  {
    fallback: <Loader />,
  }
);
//Leave Pages
export const Leave = loadable(() => import("pages/leave"), {
  fallback: <Loader />,
});
export const ContentLeave = loadable(() => import("pages/leave/content"));
export const AddLeave = loadable(() => import("pages/leave/add"));
export const DetailLeave = loadable(() => import("pages/leave/edit"));
export const ImportRemainingLeave = loadable(
  () => import("pages/leave/import/remainingLeave"),
  {
    fallback: <Loader />,
  }
);
//client visit pages
export const ClientVisit = loadable(() => import("pages/clientVisit"), {
  fallback: <Loader />,
});
//=====================================================//

//Tracking Pages
export const Tracking = loadable(() => import("pages/tracking"), {
  fallback: <Loader />,
});
export const DetailTracking = loadable(() => import("pages/tracking/detail"), {
  fallback: <Loader />,
});

//Recruitment Pages
export const CompanyProfile = loadable(
  () => import("pages/recruitmentProfile"),
  {
    fallback: <Loader />,
  }
);
export const EditCompanyProfile = loadable(
  () => import("pages/recruitmentProfile/edit"),
  {
    fallback: <Loader />,
  }
);
export const RecruitmentManagement = loadable(
  () => import("pages/recruitmentManagement"),
  {
    fallback: <Loader />,
  }
);
export const ContentRecruitmentManagement = loadable(
  () => import("pages/recruitmentManagement/content/StageTemplateRecruitment"),
  {
    fallback: <Loader />,
  }
);
export const AddRecruitmentStage = loadable(() =>
  import("pages/recruitmentManagement/add")
);
export const EditRecruitmentStage = loadable(() =>
  import("pages/recruitmentManagement/edit")
);
export const DeleteRecruitmentStage = loadable(() =>
  import("pages/recruitmentManagement/delete")
);
export const AddRecruitmentTemplate = loadable(() =>
  import("pages/recruitmentManagement/add")
);
export const EditRecruitmentTemplate = loadable(() =>
  import("pages/recruitmentManagement/edit")
);
export const DeleteRecruitmentTemplate = loadable(() =>
  import("pages/recruitmentManagement/delete")
);
export const ContentRecruitmentBroadcast = loadable(() =>
  import("pages/recruitmentManagement/content/BroadcastRecruitment")
);
export const RecruitmentJob = loadable(() => import("pages/recruitmentJob"), {
  fallback: <Loader />,
});
export const ContentRecruitmentJob = loadable(
  () => import("pages/recruitmentJob/content"),
  {
    fallback: <Loader />,
  }
);
export const AddRecruitmentJob = loadable(() =>
  import("pages/recruitmentJob/add")
);
export const AddRecruitmentJobDescription = loadable(() =>
  import("pages/recruitmentJob/add/AddJobDescription")
);
export const AddRecruitmentJobRegistration = loadable(() =>
  import("pages/recruitmentJob/add/AddJobRegistration")
);
export const AddRecruitmentJobStages = loadable(() =>
  import("pages/recruitmentJob/add/AddJobStages")
);
export const DetailRecruitmentJob = loadable(
  () => import("pages/recruitmentJob/detail"),
  {
    fallback: <Loader />,
  }
);
export const ContentDetailJob = loadable(() =>
  import("pages/recruitmentJob/detail/content/DetailJob")
);
export const ContentCandidateJob = loadable(() =>
  import("pages/recruitmentJob/detail/content/CandidateJob")
);
export const ContentEditJob = loadable(() =>
  import("pages/recruitmentJob/detail/content/EditJob")
);
export const RejectCandidate = loadable(() =>
  import("pages/recruitmentJob/detail/reject")
);
export const EditRecruitmentJobDescription = loadable(() =>
  import("pages/recruitmentJob/detail/edit/EditJobDescription")
);
export const EditRecruitmentJobRegistration = loadable(() =>
  import("pages/recruitmentJob/detail/edit/EditJobRegistration")
);
export const EditRecruitmentJobStages = loadable(() =>
  import("pages/recruitmentJob/detail/edit/EditJobStages")
);
export const RecruitmentCandidate = loadable(
  () => import("pages/recruitmentCandidate"),
  {
    fallback: <Loader />,
  }
);
export const ImportRecruitmentCandidate = loadable(() =>
  import("pages/recruitmentCandidate/import")
);
export const AddRecruitmentCandidate = loadable(() =>
  import("pages/recruitmentCandidate/add")
);
export const DetailRecruitmentCandidate = loadable(
  () => import("pages/recruitmentCandidate/detail"),
  {
    fallback: <Loader />,
  }
);
export const ContentDetailCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/content/DetailCandidate")
);
export const EditCandidate = loadable(() =>
  import("pages/recruitmentCandidate/edit")
);
export const DeleteCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/delete/DeleteNote")
);
export const ContentSendMessageCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/content/SendMessageCandidate")
);
export const ContentNoteCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/content/NoteCandidate")
);
export const DeleteNoteCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/delete/DeleteNote")
);
export const AddNoteCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/add/AddNote")
);
export const EditNoteCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/edit/EditNote")
);
export const ContentActivityCandidate = loadable(() =>
  import("pages/recruitmentCandidate/detail/content/ActivityCandidate")
);

//Payroll Pages
export const Payroll = loadable(() => import("pages/payroll"), {
  fallback: <Loader />,
});
export const DetailPayroll = loadable(() => import("pages/payroll/detail"), {
  fallback: <Loader />,
});
export const PaymentPayroll = loadable(() => import("pages/payroll/payment"), {
  fallback: <Loader />,
});
export const ImportPayroll = loadable(
  () => import("pages/payroll/import/payroll"),
  {
    fallback: <Loader />,
  }
);
export const ImportManualPayrollComponent = loadable(
  () => import("pages/payroll/import/manualComponent"),
  {
    fallback: <Loader />,
  }
);
export const ImportPayrollNote = loadable(
  () => import("pages/payroll/import/payrollNote"),
  {
    fallback: <Loader />,
  }
);

//============================finance Pages=======================//
//Cash Receipt Pages
export const CashReceipt = loadable(() => import("pages/cashReceipt"), {
  fallback: <Loader />,
});
export const ContentCashReceipt = loadable(() =>
  import("pages/cashReceipt/content")
);
export const AddCashReceipt = loadable(() => import("pages/cashReceipt/add"));
export const DetailCashReceipt = loadable(() =>
  import("pages/cashReceipt/detail")
);
export const ImportCashReceipt = loadable(
  () => import("pages/cashReceipt/import"),
  {
    fallback: <Loader />,
  }
);
//Reimbursement Pages
export const Reimbursement = loadable(() => import("pages/reimburse"), {
  fallback: <Loader />,
});
export const DetailReimburse = loadable(() => import("pages/reimburse/detail"));
export const AddReimburse = loadable(() => import("pages/reimburse/add"));
export const EditReimburse = loadable(() => import("pages/reimburse/edit"));
//Petty Cash Pages
export const PettyCash = loadable(() => import("pages/pettyCash"), {
  fallback: <Loader />,
});
export const AddPettyCash = loadable(() => import("pages/pettyCash/add"), {
  fallback: <Loader />,
});
export const EditPettyCash = loadable(() => import("pages/pettyCash/edit"), {
  fallback: <Loader />,
});
export const DetailPettyCash = loadable(
  () => import("pages/pettyCash/detail"),
  {
    fallback: <Loader />,
  }
);
export const ApprovalPettyCash = loadable(() =>
  import("pages/pettyCash/detail/approval")
);
//=======================================================//

//Approval Pages
export const Approval = loadable(() => import("pages/approval"), {
  fallback: <Loader />,
});
export const ContentApproval = loadable(() => import("pages/approval/content"));

//Personal Data Change Pages
export const DetailPersonalDataChange = loadable(() =>
  import("pages/personalDataChange/detail")
);

//Timeline Pages
export const Timeline = loadable(() => import("pages/timeline"), {
  fallback: <Loader />,
});
export const ContentTimeline = loadable(() => import("pages/timeline/content"));
export const ContentAnnouncement = loadable(() =>
  import("pages/timeline/content/Announcement")
);
export const DetailContentTimeline = loadable(() =>
  import("pages/timeline/detail/TimelineDetail")
);
export const DetailContentAnnouncement = loadable(() =>
  import("pages/timeline/edit")
);
export const ReadDetailAnnouncement = loadable(() =>
  import("pages/timeline/detail/ReadDetail")
);
export const AddAnnouncement = loadable(() => import("pages/timeline/add"));

//Client Pages
export const Client = loadable(() => import("pages/client"), {
  fallback: <Loader />,
});
export const ImportClient = loadable(() => import("pages/client/import"), {
  fallback: <Loader />,
});
export const AddClient = loadable(() => import("pages/client/add"), {
  fallback: <Loader />,
});
export const EditClient = loadable(() => import("pages/client/edit"), {
  fallback: <Loader />,
});

//Report Pages
export const Report = loadable(() => import("pages/report"), {
  fallback: <Loader />,
});
export const ReportTaxPermanentEmployeeReference = loadable(
  () => import("pages/report/taxPermanentEmployeeReference"),
  {
    fallback: <Loader />,
  }
);
export const ReportTaxWithholdingAnnualPermanentEmployee = loadable(
  () => import("pages/report/taxWithholdingAnnualPermanentEmployee"),
  {
    fallback: <Loader />,
  }
);
export const ReportTaxWithholdingAnnualFreelanceEmployee = loadable(
  () => import("pages/report/taxWithholdingAnnualFreelanceEmployee"),
  {
    fallback: <Loader />,
  }
);
export const ReportTaxPermanentEmployeeMonthly = loadable(
  () => import("pages/report/taxPermanentEmployeeMonthly"),
  {
    fallback: <Loader />,
  }
);
export const ReportTaxWithholdingMonthlyRecap = loadable(
  () => import("pages/report/taxWithholdingMonthlyRecap"),
  {
    fallback: <Loader />,
  }
);
export const ReportTaxWithholdingAnnualRecap = loadable(
  () => import("pages/report/taxWithholdingAnnualRecap"),
  {
    fallback: <Loader />,
  }
);
export const ReportPayrollSummary = loadable(
  () => import("pages/report/payrollSummary"),
  {
    fallback: <Loader />,
  }
);
export const ReportPayrollSummaryPerOrganization = loadable(
  () => import("pages/report/payrollSummaryPerOrganization"),
  {
    fallback: <Loader />,
  }
);
export const ReportPayrollSummaryPerComponent = loadable(
  () => import("pages/report/payrollSummaryPerComponent"),
  {
    fallback: <Loader />,
  }
);
export const ReportPayroll = loadable(() => import("pages/report/payroll"), {
  fallback: <Loader />,
});
export const DetailReportPayroll = loadable(
  () => import("pages/report/payroll/detail"),
  {
    fallback: <Loader />,
  }
);
export const DetailReportPayrollSummary = loadable(
  () => import("pages/report/payrollSummary/detail"),
  {
    fallback: <Loader />,
  }
);
export const DetailReportPayrollSummaryPerOrganization = loadable(
  () => import("pages/report/payrollSummaryPerOrganization/detail"),
  {
    fallback: <Loader />,
  }
);
export const DetailReportSummaryPerComponent = loadable(
  () => import("pages/report/payrollSummaryPerComponent/detail"),
  {
    fallback: <Loader />,
  }
);
export const ReportBpjsEmployement = loadable(
  () => import("pages/report/bpjsEmployement"),
  {
    fallback: <Loader />,
  }
);
export const ReportBpjsHelathcare = loadable(
  () => import("pages/report/bpjsHealthcare"),
  {
    fallback: <Loader />,
  }
);
export const ReportCoretaxMonthlyWithholdingPermanentEmployees = loadable(
  () => import("pages/report/coretaxMonthlyWithholdingPermanentEmployees"),
  {
    fallback: <Loader />,
  }
);
export const ReportCoretaxFinalNonFinalWithholdingOtherThanPermanentEmployees =
  loadable(
    () =>
      import(
        "pages/report/coretaxFinalNonFinalWithholdingOtherThanPermanentEmployees"
      ),
    {
      fallback: <Loader />,
    }
  );
export const ReportCoretaxWithholdingTaxArticle26ForForeignTaxpayers = loadable(
  () =>
    import("pages/report/coretaxWithholdingTaxArticle26ForForeignTaxpayers"),
  {
    fallback: <Loader />,
  }
);
export const ReportCoretaxWithholdingTaxCertificateA1 = loadable(
  () => import("pages/report/coretaxWithholdingTaxCertificateA1"),
  {
    fallback: <Loader />,
  }
);
export const ReportCoretaxWithholdingTaxCertificateA2 = loadable(
  () => import("pages/report/coretaxWithholdingTaxCertificateA2"),
  {
    fallback: <Loader />,
  }
);
export const ReportImport = loadable(() => import("pages/report/import"), {
  fallback: <Loader />,
});
export const DetailReportImport = loadable(
  () => import("pages/report/import/detail"),
  {
    fallback: <Loader />,
  }
);
export const ReportExport = loadable(() => import("pages/report/export"), {
  fallback: <Loader />,
});

//Accounting Pages
export const Accounting = loadable(() => import("pages/accounting"), {
  fallback: <Loader />,
});
export const AccountingSuccess = loadable(
  () => import("pages/accounting/SuccessIntegration"),
  {
    fallback: <Loader />,
  }
);

//Task Pages
export const Task = loadable(() => import("pages/task"), {
  fallback: <Loader />,
});
export const DetailTask = loadable(() => import("pages/task/detail"), {
  fallback: <Loader />,
});
export const AddTask = loadable(() => import("pages/task/add"));
export const EditTask = loadable(() => import("pages/task/edit"));
export const DuplicateTask = loadable(() => import("pages/task/duplicate"));

//Kpi Pages
export const MainKpiForm = loadable(() => import("pages/kpi/form"), {
  fallback: <Loader />,
});
export const AddKpiForm = loadable(() => import("pages/kpi/form/add"), {
  fallback: <Loader />,
});
export const EditKpiForm = loadable(() => import("pages/kpi/form/edit"), {
  fallback: <Loader />,
});
export const DetailKpiForm = loadable(() => import("pages/kpi/form/detail"), {
  fallback: <Loader />,
});
export const MainKpiTimeline = loadable(() => import("pages/kpi/timeline"), {
  fallback: <Loader />,
});
export const AddKpiTimeline = loadable(() => import("pages/kpi/timeline/add"), {
  fallback: <Loader />,
});
export const EditKpiTimeline = loadable(
  () => import("pages/kpi/timeline/edit"),
  {
    fallback: <Loader />,
  }
);
export const KpiTimelinePeriodStep = loadable(
  () => import("pages/kpi/timeline/content/TimelinePeriodStep"),
  {
    fallback: <Loader />,
  }
);
export const KpiEmployeesStep = loadable(
  () => import("pages/kpi/timeline/content/EmployeesStep"),
  {
    fallback: <Loader />,
  }
);
export const KpiAssessmentStep = loadable(
  () => import("pages/kpi/timeline/content/AssesmentStep"),
  {
    fallback: <Loader />,
  }
);
export const MainKpiReview = loadable(() => import("pages/kpi/review"), {
  fallback: <Loader />,
});
export const DetailKpiReview = loadable(
  () => import("pages/kpi/review/detail"),
  {
    fallback: <Loader />,
  }
);
export const DetailKpiReviewEmployee = loadable(
  () => import("pages/kpi/review/employeeDetail"),
  {
    fallback: <Loader />,
  }
);

//===================Settings Pages====================//
export const Settings = loadable(() => import("pages/settings"), {
  fallback: <Loader />,
});
export const Company = loadable(() => import("pages/settings/company"), {
  fallback: <Loader />,
});
export const CompanyInfo = loadable(() =>
  import("pages/settings/company/companyInfo")
);
export const JobLevel = loadable(() =>
  import("pages/settings/company/jobLevel")
);
export const DetailJobLevel = loadable(() =>
  import("pages/settings/company/jobLevel/edit")
);
export const AddJobLevel = loadable(() =>
  import("pages/settings/company/jobLevel/add")
);
export const DeleteJobLevel = loadable(() =>
  import("pages/settings/company/jobLevel/delete")
);
export const OrganitationalStructure = loadable(() =>
  import("pages/settings/company/organizationalStructure")
);
export const DetailOrganitationalStructure = loadable(() =>
  import("pages/settings/company/organizationalStructure/detail")
);
export const AddOrganitationalStructure = loadable(() =>
  import("pages/settings/company/organizationalStructure/add")
);
export const EditOrganitationalStructure = loadable(() =>
  import("pages/settings/company/organizationalStructure/edit")
);
export const Position = loadable(() =>
  import("pages/settings/company/position")
);
export const DetailPosition = loadable(() =>
  import("pages/settings/company/position/detail")
);
export const AddPosition = loadable(() =>
  import("pages/settings/company/position/add")
);
export const EditPosition = loadable(() =>
  import("pages/settings/company/position/edit")
);
export const CompanyPolicy = loadable(
  () => import("pages/settings/company/companyPolicy"),
  {
    fallback: <Loader />,
  }
);
export const AddCompanyPolicy = loadable(() =>
  import("pages/settings/company/companyPolicy/add")
);
export const DetailCompanyPolicy = loadable(() =>
  import("pages/settings/company/companyPolicy/edit")
);
export const AnnualLeaveSetting = loadable(
  () => import("pages/settings/annualLeave"),
  {
    fallback: <Loader />,
  }
);
export const SpecialLeaveSetting = loadable(
  () => import("pages/settings/specialLeave"),
  {
    fallback: <Loader />,
  }
);
export const SickLeaveSetting = loadable(
  () => import("pages/settings/sickLeave"),
  {
    fallback: <Loader />,
  }
);
export const ScheduleSetting = loadable(
  () => import("pages/settings/schedule"),
  {
    fallback: <Loader />,
  }
);
export const DetailScheduleSetting = loadable(
  () => import("pages/settings/schedule/detail"),
  {
    fallback: <Loader />,
  }
);
export const AddScheduleSetting = loadable(
  () => import("pages/settings/schedule/add"),
  {
    fallback: <Loader />,
  }
);
export const EditScheduleSetting = loadable(
  () => import("pages/settings/schedule/edit"),
  {
    fallback: <Loader />,
  }
);
export const SelectShift = loadable(() =>
  import("pages/settings/schedule/shift")
);
export const AddShift = loadable(() =>
  import("pages/settings/schedule/shift/add")
);
export const EditShift = loadable(() =>
  import("pages/settings/schedule/shift/edit")
);
export const CalendarSetting = loadable(
  () => import("pages/settings/calendar"),
  {
    fallback: <Loader />,
  }
);
export const AddCalendarSetting = loadable(() =>
  import("pages/settings/calendar/add")
);
export const DetailCalendarSetting = loadable(() =>
  import("pages/settings/calendar/edit")
);
export const PayrollSetting = loadable(() => import("pages/settings/payroll"), {
  fallback: <Loader />,
});
export const MainPayroll = loadable(() =>
  import("pages/settings/payroll/payroll")
);
export const AddPayrollSalarySlip = loadable(() =>
  import("pages/settings/payroll/payroll/add")
);
export const EditPayrollSalarySlip = loadable(() =>
  import("pages/settings/payroll/payroll/edit")
);
export const AddIncomeComponent = loadable(() =>
  import("pages/settings/payroll/payroll/add/AddIncomeComponent")
);
export const AddCutComponent = loadable(() =>
  import("pages/settings/payroll/payroll/add/AddCutComponent")
);
export const DetailIncomeComponents = loadable(() =>
  import("pages/settings/payroll/payroll/detail/DetailIncomeComponent")
);
export const DetailCutComponents = loadable(() =>
  import("pages/settings/payroll/payroll/detail/DetailCutComponent")
);
export const EditIncomeComponent = loadable(() =>
  import("pages/settings/payroll/payroll/edit/EditIncomeComponent")
);
export const EditCutComponent = loadable(() =>
  import("pages/settings/payroll/payroll/edit/EditCutComponent")
);
export const SortPayrollComponents = loadable(() =>
  import("components/apps/SalarySlip/Content/SortPayrollComponent")
);
export const ImplementationSalarySlip = loadable(() =>
  import("pages/settings/payroll/payroll/implementation")
);
export const Thr = loadable(() => import("pages/settings/payroll/thr"));
export const LeaveAllowance = loadable(() =>
  import("pages/settings/payroll/leaveAllowance")
);
export const UnpaidLeave = loadable(() =>
  import("pages/settings/payroll/unpaidLeave")
);
export const OvertimePay = loadable(() =>
  import("pages/settings/payroll/overtimePay")
);
export const ProRate = loadable(
  () => import("pages/settings/payroll/proRate"),
  {
    fallback: <Loader />,
  }
);
export const TaxPayroll = loadable(() => import("pages/settings/payroll/tax"));
export const BpjsPayroll = loadable(() =>
  import("pages/settings/payroll/bpjs")
);
export const RoundingPayroll = loadable(() =>
  import("pages/settings/payroll/rounding")
);
export const SeverancesPayroll = loadable(() =>
  import("pages/settings/payroll/severances")
);
export const HistoryBpjsEmployement = loadable(() =>
  import("pages/settings/payroll/bpjs/historyBpjsEmployement")
);
export const HistoryBpjsHealthcare = loadable(() =>
  import("pages/settings/payroll/bpjs/historyBpjsHealthcare")
);
export const CompanyAccount = loadable(() =>
  import("pages/settings/payroll/companyAccount")
);
export const ImportMultiplierBpjs = loadable(
  () => import("pages/settings/payroll/bpjs/import/bpjsMultiplier"),
  {
    fallback: <Loader />,
  }
);
export const GradingPayroll = loadable(() =>
  import("pages/settings/payroll/grading")
);
export const ApprovalSetting = loadable(
  () => import("pages/settings/approval"),
  {
    fallback: <Loader />,
  }
);
export const DetailApprovalSetting = loadable(
  () => import("pages/settings/approval/detail"),
  {
    fallback: <Loader />,
  }
);
export const AddApprovalSetting = loadable(
  () => import("pages/settings/approval/add"),
  {
    fallback: <Loader />,
  }
);
export const EditApprovalSetting = loadable(
  () => import("pages/settings/approval/edit"),
  {
    fallback: <Loader />,
  }
);
export const Profile = loadable(() => import("pages/settings/profile"), {
  fallback: <Loader />,
});
export const Roles = loadable(() => import("pages/settings/roles"), {
  fallback: <Loader />,
});
export const AddRoles = loadable(() => import("pages/settings/roles/add"), {
  fallback: <Loader />,
});
export const EditRoles = loadable(() => import("pages/settings/roles/edit"), {
  fallback: <Loader />,
});
export const Users = loadable(() => import("pages/settings/users"), {
  fallback: <Loader />,
});
export const BusinessFlow = loadable(
  () => import("pages/settings/businessFlow"),
  {
    fallback: <Loader />,
  }
);
export const Notification = loadable(
  () => import("pages/settings/notification"),
  {
    fallback: <Loader />,
  }
);
export const Setup = loadable(() => import("pages/settings/setup"), {
  fallback: <Loader />,
});
export const SetupSuccess = loadable(
  () => import("pages/settings/setup/SetupSuccess"),
  {
    fallback: <Loader />,
  }
);
export const AccountMapping = loadable(
  () => import("pages/settings/accountMapping"),
  {
    fallback: <Loader />,
  }
);
export const MobileMenu = loadable(() => import("pages/settings/mobileMenu"), {
  fallback: <Loader />,
});
export const AttendanceValidationSetting = loadable(
  () => import("pages/settings/attendanceValidation"),
  {
    fallback: <Loader />,
  }
);
export const AttendanceValidationPresenceSetting = loadable(
  () =>
    import(
      "pages/settings/attendanceValidation/content/SettingAttendanceLogPresence"
    ),
  {
    fallback: <Loader />,
  }
);
export const AttendanceValidationOvertimeSetting = loadable(
  () =>
    import(
      "pages/settings/attendanceValidation/content/SettingAttendanceLogOvertime"
    ),
  {
    fallback: <Loader />,
  }
);
export const AttendanceValidationClientVisitSetting = loadable(
  () =>
    import(
      "pages/settings/attendanceValidation/content/SettingAttendanceLogClientVisit"
    ),
  {
    fallback: <Loader />,
  }
);
export const AttendanceLocations = loadable(
  () => import("pages/settings/attendanceLocation"),
  {
    fallback: <Loader />,
  }
);
export const AddAttendanceLocations = loadable(
  () => import("pages/settings/attendanceLocation/add"),
  {
    fallback: <Loader />,
  }
);
export const EditAttendanceLocations = loadable(
  () => import("pages/settings/attendanceLocation/edit"),
  {
    fallback: <Loader />,
  }
);
export const Billing = loadable(() => import("pages/settings/billing"), {
  fallback: <Loader />,
});
export const UpgradeBilling = loadable(
  () => import("pages/settings/billing/UpgradeBilling"),
  {
    fallback: <Loader />,
  }
);
export const AddAddonBilling = loadable(
  () => import("pages/settings/billing/AddAddon"),
  {
    fallback: <Loader />,
  }
);
export const UpgradeEmployeeBilling = loadable(
  () => import("pages/settings/billing/UpgradeEmployee"),
  {
    fallback: <Loader />,
  }
);
export const SuccessBilling = loadable(
  () => import("pages/settings/billing/Success"),
  { fallback: <Loader /> }
);
export const FailedBilling = loadable(
  () => import("pages/settings/billing/Failed"),
  {
    fallback: <Loader />,
  }
);
export const SettingTemplate = loadable(
  () => import("pages/settings/template"),
  {
    fallback: <Loader />,
  }
);
export const EmailTemplate = loadable(() =>
  import("pages/settings/template/content/Email")
);

export const MobileAppsTemplate = loadable(() =>
  import("pages/settings/template/content/MobileApps")
);
export const LayoutSalarySlip = loadable(
  () => import("pages/settings/layoutSalarySlip"),
  {
    fallback: <Loader />,
  }
);
export const SettingOpenApi = loadable(() => import("pages/settings/openApi"), {
  fallback: <Loader />,
});
export const SettingAddOpenApi = loadable(
  () => import("pages/settings/openApi/add"),
  {
    fallback: <Loader />,
  }
);
export const SettingDetailOpenApi = loadable(
  () => import("pages/settings/openApi/detail"),
  {
    fallback: <Loader />,
  }
);
export const SettingAuditLog = loadable(
  () => import("pages/settings/auditLog"),
  {
    fallback: <Loader />,
  }
);
export const SettingCashReceipt = loadable(
  () => import("pages/settings/cashReceipt"),
  {
    fallback: <Loader />,
  }
);
export const SettingReimbursement = loadable(
  () => import("pages/settings/reimbursement"),
  {
    fallback: <Loader />,
  }
);
export const SettingReimbursementPlafon = loadable(() =>
  import("pages/settings/reimbursement/plafon")
);
export const SettingReimbursementCategory = loadable(() =>
  import("pages/settings/reimbursement/categories")
);
export const AddSettingReimbursementCategory = loadable(() =>
  import("pages/settings/reimbursement/categories/add")
);
export const EditSettingReimbursementCategory = loadable(() =>
  import("pages/settings/reimbursement/categories/edit")
);
export const SettingImportPlafonCashReceipt = loadable(
  () => import("pages/settings/cashReceipt/import"),
  {
    fallback: <Loader />,
  }
);
export const SettingImportPlafonReimbursement = loadable(
  () => import("pages/settings/reimbursement/import"),
  {
    fallback: <Loader />,
  }
);
export const SettingTracking = loadable(
  () => import("pages/settings/locationTracking"),
  {
    fallback: <Loader />,
  }
);
export const SettingOvertime = loadable(
  () => import("pages/settings/overtime"),
  {
    fallback: <Loader />,
  }
);
export const AddSettingOvertime = loadable(
  () => import("pages/settings/overtime/add"),
  {
    fallback: <Loader />,
  }
);
export const DetailSettingOvertime = loadable(
  () => import("pages/settings/overtime/detail"),
  {
    fallback: <Loader />,
  }
);
export const EditSettingOvertime = loadable(
  () => import("pages/settings/overtime/edit"),
  {
    fallback: <Loader />,
  }
);
export const Numbers = loadable(() => import("pages/settings/numbers"), {
  fallback: <Loader />,
});
export const Fingerprint = loadable(
  () => import("pages/settings/fingerprint"),
  {
    fallback: <Loader />,
  }
);
export const SSO = loadable(() => import("pages/settings/sso"), {
  fallback: <Loader />,
});
export const AddDomainSSO = loadable(() => import("pages/settings/sso/add"));
export const VerifyDomainSSO = loadable(() =>
  import("pages/settings/sso/verify")
);
export const VerificationSuccessDomainSSO = loadable(() =>
  import("pages/settings/sso/success")
);
export const Translations = loadable(
  () => import("pages/settings/translation"),
  {
    fallback: <Loader />,
  }
);
export const SelectDeviceFingerprint = loadable(
  () => import("pages/settings/fingerprint/selectDevice"),
  {
    fallback: <Loader />,
  }
);
export const AddFingerprint = loadable(
  () => import("pages/settings/fingerprint/add"),
  {
    fallback: <Loader />,
  }
);
export const EditFingerprint = loadable(
  () => import("pages/settings/fingerprint/edit"),
  {
    fallback: <Loader />,
  }
);
export const HistoryFingerprint = loadable(
  () => import("pages/settings/fingerprint/history"),
  {
    fallback: <Loader />,
  }
);
export const SynchronizationFingerprint = loadable(
  () => import("pages/settings/fingerprint/synchronization"),
  {
    fallback: <Loader />,
  }
);
export const SettingPaymentConnect = loadable(
  () => import("pages/settings/paymentConnect"),
  {
    fallback: <Loader />,
  }
);
export const DetailSettingPaymentConnect = loadable(
  () => import("pages/settings/paymentConnect/detail"),
  {
    fallback: <Loader />,
  }
);
export const SettingTask = loadable(() => import("pages/settings/task"), {
  fallback: <Loader />,
});
export const SettingPayrollTask = loadable(() =>
  import("pages/settings/task/payroll")
);
export const SettingClientVisitTask = loadable(() =>
  import("pages/settings/task/clientVisit")
);
export const MainSettingPettyCash = loadable(
  () => import("pages/settings/pettyCash"),
  {
    fallback: <Loader />,
  }
);
export const PettyCashSettings = loadable(() =>
  import("pages/settings/pettyCash/settings")
);
export const AddPettyCashSettings = loadable(() =>
  import("pages/settings/pettyCash/settings/add")
);
export const EditPettyCashSettings = loadable(() =>
  import("pages/settings/pettyCash/settings/edit")
);
export const PettyCashCategories = loadable(() =>
  import("pages/settings/pettyCash/categories")
);
export const AddPettyCashCategories = loadable(() =>
  import("pages/settings/pettyCash/categories/add")
);
export const EditPettyCashCategories = loadable(() =>
  import("pages/settings/pettyCash/categories/edit")
);
//======================================================//

//Faq Pages
export const Faq = loadable(() => import("pages/faq"), {
  fallback: <Loader />,
});
export const DetailFaq = loadable(() => import("pages/faq/Detail"), {
  fallback: <Loader />,
});

//Referral Pages
export const Referral = loadable(() => import("pages/referral"), {
  fallback: <Loader />,
});

//Company Pages
export const ListCompany = loadable(() => import("pages/companies"), {
  fallback: <Loader />,
});
export const AddCompany = loadable(() => import("pages/companies/add"), {
  fallback: <Loader />,
});

//Not Found Pages
export const Page404 = loadable(() => import("pages/404"), {
  fallback: <Loader />,
});
